import React from 'react';
import styled from 'styled-components';

const Facebook = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
    className="facebook"
  >
    <title>Facebook</title>
    <path d="M15 0C6.71631 0 0 6.75716 0 15.0912C0 22.623 5.48438 28.8667 12.6565 30V19.4544H8.84678V15.0912H12.6562V11.7656C12.6562 7.98155 14.8966 5.89324 18.322 5.89324C19.9632 5.89324 21.6803 6.18829 21.6803 6.18829V9.90214H19.7883C19.7593 9.90214 19.7303 9.90244 19.7019 9.90303C18.1087 9.93457 17.4853 10.8412 17.3657 11.8672C17.3657 11.8684 17.3654 11.8696 17.3654 11.8705C17.3634 11.8885 17.3613 11.9062 17.3596 11.9241C17.3596 11.9247 17.3596 11.925 17.3593 11.9256C17.3578 11.9406 17.3566 11.956 17.3552 11.971C17.3549 11.9742 17.3546 11.9778 17.3543 11.981C17.3531 11.9946 17.3522 12.0081 17.3514 12.0214C17.3511 12.0264 17.3505 12.0314 17.3502 12.0364C17.3496 12.0476 17.349 12.0588 17.3484 12.07C17.3481 12.0774 17.3476 12.0848 17.3473 12.0921C17.3464 12.1092 17.3458 12.1263 17.3452 12.1437C17.3452 12.1452 17.3452 12.1464 17.3449 12.1478C17.3443 12.1638 17.344 12.18 17.3438 12.1959C17.3438 12.1985 17.3438 12.2012 17.3435 12.2038C17.3432 12.2224 17.3432 12.2413 17.3432 12.2599V15.0912H21.503L20.8389 19.4544H17.3435V29.9997C24.5156 28.8687 30 22.625 30 15.0912C30 6.75716 23.2837 0 15 0Z" />
  </svg>
);

const Instagram = () => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    xmlns="http://www.w3.org/2000/svg"
    className="instagram"
  >
    <title>Instagram</title>
    <path d="M14.5006 2.61227C18.3727 2.61227 18.8315 2.62699 20.3597 2.69723C21.7735 2.7618 22.5416 2.99742 23.0525 3.1968C23.7288 3.45961 24.2125 3.77453 24.7201 4.28203C25.2276 4.78953 25.5414 5.27211 25.8042 5.94953C26.0025 6.46043 26.2392 7.22848 26.3038 8.64223C26.374 10.1715 26.3888 10.6303 26.3888 14.5011C26.3888 18.372 26.374 18.8319 26.3038 20.36C26.2392 21.7738 26.0036 22.5418 25.8042 23.0527C25.5414 23.729 25.2265 24.2127 24.7201 24.7202C24.2125 25.2277 23.73 25.5415 23.0525 25.8043C22.5416 26.0026 21.7735 26.2393 20.3597 26.3039C18.8303 26.3741 18.3727 26.3889 14.5006 26.3889C10.6285 26.3889 10.1697 26.3741 8.64143 26.3039C7.22763 26.2393 6.45955 26.0037 5.94863 25.8043C5.27232 25.5415 4.78859 25.2266 4.28107 24.7202C3.77355 24.2127 3.45974 23.7302 3.19692 23.0527C2.99867 22.5418 2.7619 21.7738 2.69733 20.36C2.62709 18.8307 2.61237 18.372 2.61237 14.5011C2.61237 10.6303 2.62709 10.1704 2.69733 8.64223C2.7619 7.22848 2.99754 6.46043 3.19692 5.94953C3.45974 5.27324 3.77468 4.78953 4.28107 4.28203C4.78745 3.77453 5.27118 3.46074 5.94863 3.1968C6.45955 2.99855 7.22763 2.7618 8.64143 2.69723C10.1697 2.62699 10.6285 2.61227 14.5006 2.61227ZM14.5006 0C10.5628 0 10.0688 0.0169922 8.52248 0.0872266C6.9784 0.157461 5.92484 0.403281 5.00156 0.76125C4.0477 1.13168 3.23884 1.62785 2.43338 2.43328C1.62792 3.23871 1.13172 4.04867 0.76128 5.0025C0.403297 5.92461 0.157467 6.97813 0.08723 8.52215C0.0169928 10.0684 0 10.5623 0 14.5C0 18.4377 0.0169928 18.9316 0.08723 20.4779C0.157467 22.0207 0.403297 23.0754 0.76128 23.9975C1.13172 24.9513 1.62792 25.7602 2.43338 26.5656C3.23997 27.3721 4.0477 27.8672 5.00156 28.2376C5.92371 28.5956 6.9784 28.8414 8.52135 28.9116C10.0688 28.983 10.5628 29 14.5006 29C18.4384 29 18.9323 28.983 20.4787 28.9128C22.0216 28.8425 23.0763 28.5967 23.9984 28.2388C24.9523 27.8683 25.7612 27.3721 26.5666 26.5667C27.3732 25.7602 27.8683 24.9525 28.2387 23.9986C28.5967 23.0765 28.8425 22.0219 28.9128 20.479C28.983 18.9327 29 18.4388 29 14.5011C29 10.5635 28.983 10.0696 28.9128 8.52328C28.8425 6.98039 28.5967 5.92574 28.2387 5.00363C27.8683 4.0498 27.3721 3.24098 26.5666 2.43555C25.7612 1.63012 24.9523 1.13168 23.9984 0.76125C23.0763 0.403281 22.0216 0.157461 20.4787 0.0872266C18.9323 0.0169922 18.4384 0 14.5006 0ZM14.5006 7.05402C10.3883 7.05402 7.0543 10.3879 7.0543 14.5C7.0543 18.6121 10.3883 21.946 14.5006 21.946C18.6128 21.946 21.9468 18.6121 21.9468 14.5C21.9468 10.3879 18.6128 7.05402 14.5006 7.05402ZM14.5006 19.3337C11.8316 19.3337 9.66667 17.17 9.66667 14.5C9.66667 11.83 11.8304 9.66629 14.5006 9.66629C17.1707 9.66629 19.3345 11.83 19.3345 14.5C19.3345 17.17 17.1696 19.3337 14.5006 19.3337ZM23.9814 6.75949C23.9814 7.72012 23.202 8.49949 22.2414 8.49949C21.2807 8.49949 20.5013 7.72012 20.5013 6.75949C20.5013 5.79887 21.2807 5.01949 22.2414 5.01949C23.202 5.01949 23.9814 5.79887 23.9814 6.75949Z" />
  </svg>
);

const Twitter = () => (
  <svg
    width="37"
    height="29"
    viewBox="0 0 37 29"
    xmlns="http://www.w3.org/2000/svg"
    className="twitter"
  >
    <title>Twitter</title>
    <path d="M11.6358 29C25.5981 29 33.2349 17.8442 33.2349 8.1699C33.2349 7.85304 33.2275 7.5376 33.2127 7.2236C34.6942 6.19023 35.9832 4.90137 37 3.43267C35.6399 4.01501 34.1762 4.40752 32.6399 4.58451C34.2072 3.67817 35.4105 2.24373 35.9773 0.53524C34.5106 1.3745 32.8856 1.98396 31.157 2.31224C29.7732 0.890639 27.8003 0 25.6173 0C21.4245 0 18.0249 3.27852 18.0249 7.32065C18.0249 7.89586 18.0915 8.45393 18.2218 8.98917C11.914 8.68373 6.31812 5.7706 2.5752 1.34024C1.92252 2.42214 1.5466 3.67959 1.5466 5.01983C1.5466 7.56044 2.88748 9.80131 4.92396 11.113C3.67928 11.0759 2.5086 10.7462 1.48592 10.1967C1.48444 10.2266 1.48444 10.258 1.48444 10.2894C1.48444 13.8349 4.10108 16.7951 7.57464 17.4659C6.93676 17.6329 6.26632 17.7229 5.57368 17.7229C5.08528 17.7229 4.60872 17.6758 4.14696 17.5901C5.1134 20.499 7.91504 22.6157 11.2391 22.6742C8.64024 24.6382 5.36796 25.8085 1.81152 25.8085C1.1988 25.8085 0.59496 25.7743 0 25.7072C3.3596 27.7882 7.3482 29 11.6358 29Z" />
  </svg>
);

const SocialIcon = ({ icon }) => {
  const components = {
    facebook: Facebook,
    instagram: Instagram,
    twitter: Twitter,
  };

  const Icon = components[icon];

  return <Icon />;
};

const SocialLinks = ({ content }) => {
  return (
    <SocialWrapper>
      {content.map(({ link_text, link_url }) => (
        <a href={link_url.url} target="_blank" rel="noreferrer" key={link_text}>
          <SocialIcon icon={link_text.toLowerCase()} />
        </a>
      ))}
    </SocialWrapper>
  );
};

export default SocialLinks;

/**
 * Styled Components
 *
 */
const SocialWrapper = styled.div`
  a {
    position: relative;

    &:hover {
      svg {
        &.facebook {
          fill: #1878f2;
        }

        &.instagram {
          fill: #f00075;
        }

        &.twitter {
          fill: #1e9bf0;
        }
      }
    }

    & + a {
      margin-left: var(--space-l);
    }

    &:after {
      content: '';
      position: absolute;
      top: -1.2rem;
      right: -1.2rem;
      bottom: -1.2rem;
      left: -1.2rem;
    }
  }

  svg {
    fill: var(--color-white);
    transition: fill 200ms var(--ease-cubic-in-out);
  }
`;
